// libraries
import React, { useState} from 'react'
import clsx from 'clsx'

// components
import RichText from '/react4xp/components/RichText'

// icons
import { AngleDown } from '/react4xp/components/Svg/Ux/Angle'

// utils
import { isNonWhitespaceString } from '/lib/reactutils/utils.js'

export interface MacroAccordionProps {
	theme: 'light' | 'dark'
	heading?: string
	accordion: Array<{
		title: string
		text: string
	}>
}

export default function MacroAccordion({
	theme,
	heading,
	accordion
}: MacroAccordionProps) {

	const [activeItems, setActiveItems] = useState<boolean[]>(new Array(accordion.length).fill(false))

	const toggle = (index: number) => {
		setActiveItems((prevItems) => {
			const updatedItems = [...prevItems]
			updatedItems[index] = !updatedItems[index]
			return updatedItems
		})
	}
	
	return (
		<div className={clsx(
			'macro__accordion',
			theme === 'light' && 'macro__accordion--light'
		)}>

			{isNonWhitespaceString(heading) && (
				<h3 className='accordion-heading'>
					{heading}
				</h3>
			)}

			<div className='accordion-list'>
				{accordion.map((item, i) => (
					<div
						key={i}
						className={clsx(
							'accordion-list__item',
							activeItems[i] && 'accordion-list__item--active'
						)}
					>

						<button
							className='accordion-list__title'
							onClick={() => toggle(i)}
						>

							<span className='text-md'>
								{item.title}
							</span>

							<AngleDown />

						</button>

						<div className='accordion-list__text'>
							<div>
								<div>
									<RichText content={item.text} />
								</div>
							</div>
						</div>

					</div>
				))}
			</div>

		</div>
	)
}